/*
*
* ***********************************Example of Usage***********************************
*
* 1 - Simple usage
*    <Dropdown options={[{id: 1, name: "first"}, {id: 2, name: "second"}]} value="2"/>
*
* 2 - Simple usage with className
*    <Dropdown options={[{id: 1, name: "first"}, {id: 2, name: "second"}]} value="2"
*              className="mt-10"/>
*
* 3 - Trigger function on Change
*    <Dropdown options={[{id: 1, name: "first"}, {id: 2, name: "second"}]} value="2"
*              handleCustomChange={function(newValue){alert(newValue);}}/>
*
* 4 - Disable it
*    <Dropdown options={[{id: 1, name: "first"}, {id: 2, name: "second"}]} value="2" disabled/>
*
* 5 - Get it's value
*    4.1 - Using this.refs.Drop1.state.value (without handleCustomChange)
*      var options = [{id: 1, name: "first"}, {id: 2, name: "second"}];
*      <Dropdown options={options} value="2" ref="Drop1" />
*       In this case, "value" works as "initialValue" (as the changes will be made in Dropdown"s
*       state)"
*    4.2 - Using handleCustomChange to alter your state, so that it will update your
*           Dropdown"s value.
*    alterState: function(value){
*      var dropValue = this.state.dropValue;
*      this.setState({dropValue: value});
*    }
*    <Dropdown options={[{id:1, name: "1"}, {id:2, name:"2"}]} value={this.state.dropValue}
*              handleCustomChange={this.alterState} />
*
* 6 - Grouping options
*    <Dropdown options={[{id: 1, name: "first", group: "active"},
*                        {id: 2, name: "second", group: "active"},
*                        {id: 3, name: "third", group: "inactive"}]},
*              groups={[{id: "active", name: "Ativo"},
*                       {id: "inactive", name: "Inativo"}]}
*              value={"1"} />
*    ###Group order is defined in "groups props"
*    ###"nogroup" id group won't show a group
*
* 7 - Simple usage with parentClassName
*    <Dropdown options={[{id: 1, name: "first"}, {id: 2, name: "second"}]} value="2"
*              parentClassName="d-b"/>
*/

"use strict";

var _ = require("underscore");
var cx = require("classnames");
var DropdownOption = require("./dropdown-option");

var Dropdown = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    options:React.PropTypes.arrayOf(React.PropTypes.object),
    groups: React.PropTypes.arrayOf(React.PropTypes.object),
    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
    disabled: React.PropTypes.bool,
    handleCustomChange: React.PropTypes.func,
    handleCustomOptionId: React.PropTypes.func,
    handleCustomOptionDisplay: React.PropTypes.func,
    className: React.PropTypes.string,
    parentClassName: React.PropTypes.string
  },
  getInitialState: function(){
    return {value: this.props.value};
  },
  getValue: function(){
    if(this.props.handleCustomChange != undefined){
      return this.props.value;
    }
    return this.state.value;
  },
  getOptions: function () {
    if (this.props.groups) {
      return this.getGroupedOptions();
    } else {
      return this.getSingleOptions(this.props.options);
    }
  },
  getGroupedOptions: function() {
    return _.map(this.props.groups, function(group) {
      var groupedOptions;
      var optionsInGroup = _.where(this.props.options, {group: group.id});
      if (optionsInGroup.length > 0) {
        groupedOptions = this.getSingleOptions(optionsInGroup);
        if(group.id == "nogroup") {
          return groupedOptions;
        } else {
          return <optgroup key={group.id} label={group.name}>{groupedOptions}</optgroup>;
        }
      }
      return;
    }.bind(this));
  },
  getSingleOptions: function(options) {
    return options.map(function(option, key) {
      return (<DropdownOption key={key}
                              option={option}
                              handleCustomId={this.props.handleCustomOptionId}
                              handleCustomDisplay={this.props.handleCustomOptionDisplay}/>);
    }.bind(this));
  },
  handleChange: function(event) {
    this.setState({value: event.target.value});
    if(this.props.handleCustomChange != undefined) {
      var eventObj = {
        value: event.target.value,
        text: event.target[event.target.selectedIndex] && event.target[event.target.selectedIndex].text
      };
      this.props.handleCustomChange(eventObj, event);
    }
  },
  render: function () {
    var isLoading = this.props.options == null || !_.isArray(this.props.options);
    var className = cx("dropdownDefault", this.props.className);
    var parentClassName = cx("selectGroup", this.props.parentClassName);

    if ( isLoading || this.props.options.length == 0) {
      return <LoadingDropdown className={className} parentClassName={parentClassName}/>;
    } else {
      return (
        <span className={parentClassName}>
          <select onChange={this.handleChange}
                  className={className}
                  value={this.getValue()}
                  disabled={this.props.disabled}>
            {this.getOptions()}
          </select>
          <span className="custom-glyphicon icon-chevron-down dropdown-caret"></span>
        </span>
      );
    }
  }
});

const LoadingDropdown = (props) => (
  <span className={props.parentClassName}>
    <select className={props.className}>
      <option></option>
      <option>Carregando...</option>
    </select>
    <span className="dropdown-caret"></span>
  </span>
);

module.exports = Dropdown;



// WEBPACK FOOTER //
// ./app/shared/components/Dropdown/dropdown.jsx